import React, { FC } from 'react';

const SubmitOnEnter: FC = () => {
  return <input type="submit" style={{ display: 'none' }} />;
};

export default SubmitOnEnter;
